/* Position each original dropdown flush with the bottom of its header. */
(() => {
  if (window.pbSimpleDropdownLoaded) return;
  window.pbSimpleDropdownLoaded = true;
  const desktop = window.matchMedia('(min-width: 990px)');
  const menus = new Map();

  function measure(nav) {
    if (!desktop.matches || !nav.isConnected) return;
    const header = nav.closest('.header-wrapper') || nav.closest('header');
    if (!header) return;
    const bottom = header.getBoundingClientRect().bottom;
    nav.style.setProperty('--pb-simple-header-bottom', `${Math.ceil(bottom)}px`);
    nav.querySelectorAll('header-menu > details').forEach(details => {
      details.style.setProperty('--pb-simple-panel-offset',
        `${Math.max(0, bottom - details.getBoundingClientRect().top)}px`);
    });
  }

  function initialize() {
    document.querySelectorAll('.pb-simple-menu').forEach(nav => {
      if (menus.has(nav)) return;
      const controller = new AbortController();
      const update = () => measure(nav);
      const observer = new ResizeObserver(update);
      observer.observe(nav.closest('.header-wrapper') || nav.closest('header'));
      nav.addEventListener('pointerdown', update, { signal: controller.signal });
      nav.addEventListener('toggle', update, { capture: true, signal: controller.signal });
      window.addEventListener('resize', update, { passive: true, signal: controller.signal });
      nav.querySelectorAll('header-menu').forEach(menu => {
        const details = menu.querySelector('details');
        const summary = details.querySelector('summary');
        let openTimer;
        let closeTimer;
        menu.addEventListener('pointerenter', event => {
          if (event.pointerType === 'touch' || !desktop.matches) return;
          clearTimeout(closeTimer);
          openTimer = setTimeout(() => {
            nav.querySelectorAll('header-menu > details[open]').forEach(other => {
              if (other !== details) {
                other.open = false;
                other.querySelector('summary').setAttribute('aria-expanded', 'false');
              }
            });
            update();
            details.open = true;
            summary.setAttribute('aria-expanded', 'true');
          }, 150);
        }, { signal: controller.signal });
        menu.addEventListener('pointerleave', () => {
          clearTimeout(openTimer);
          closeTimer = setTimeout(() => {
            details.open = false;
            summary.setAttribute('aria-expanded', 'false');
          }, 250);
        }, { signal: controller.signal });
        controller.signal.addEventListener('abort', () => {
          clearTimeout(openTimer);
          clearTimeout(closeTimer);
        });
      });
      nav.addEventListener('keydown', event => {
        const details = event.target.closest('header-menu > details');
        if (!details) return;
        const summary = details.querySelector('summary');
        if (event.target === summary && ['ArrowDown', 'ArrowUp'].includes(event.key)) {
          event.preventDefault();
          nav.querySelectorAll('header-menu > details[open]').forEach(other => {
            if (other !== details) other.removeAttribute('open');
          });
          details.open = true;
          summary.setAttribute('aria-expanded', 'true');
          update();
          const links = details.querySelectorAll(':scope > ul > li > a');
          const target = event.key === 'ArrowUp' ? links[links.length - 1] : links[0];
          target?.focus();
        }
        if (event.key === 'Escape' && details.open) {
          event.preventDefault();
          details.open = false;
          summary.setAttribute('aria-expanded', 'false');
          summary.focus();
        }
      }, { signal: controller.signal });
      menus.set(nav, { observer, controller });
      update();
    });
  }

  document.addEventListener('shopify:section:unload', event => {
    menus.forEach(({ observer, controller }, nav) => {
      if (event.target.contains(nav)) {
        observer.disconnect();
        controller.abort();
        menus.delete(nav);
      }
    });
  });
  document.addEventListener('shopify:section:load', initialize);
  initialize();
})();
